import React from 'react'

// This component is used to create an empty div element to use inside a flex container.
// It can be added into a flex component and use to justify content leaving space around with easier alignment rules.
const FlexSpacer = (): React.ReactElement => <div></div>

export default FlexSpacer
